import fvSubassembly from "../fvSubassembly"
export default class fvPolylineObj extends fvSubassembly{
    constructor(sContent,parent,system,callback){
        super(sContent,parent,system);
        this.initPoints = JSON.parse(JSON.stringify(this.points));
        //用于流动属性 不勾选“只有流动时才显示”时使用
        this.create();
        if(this.isDelayedWaiting){
            this.complete = callback;
        }else{
            callback(this);
        }
        this.createSucss();
        this.isHide = true;
        if(this.animation.fvHide){
            this.isHide = false;
        }
    }

    init(){
        super.init();
        // 根据x y 因边框、缩放改变导致绘制多折线重新计算
        for(var i = 0; i<this.points.length; i++){
            var points0 = this.initPoints[i][0] + this.initPoints[i][0] * this.frameScaleX ;
            var points1 = this.initPoints[i][1] + this.initPoints[i][1] * this.frameScaleY ;
            this.points[i][0] =(points0* this.magnification.x);
            this.points[i][1] = (points1* this.magnification.y);
        }
        this.m_points = [];
        for(var i = 0; i<this.points.length; i++){
            this.m_points.push({
                x:this.points[i][0],
                y:this.points[i][1]
            });
        }
    }

    GetPtr(parm){
            parm.nCount = this.points.length;
            parm.pPotPtr = new Array(parm.nCount);//备份点信息
            for(var i=0; i<parm.nCount; i++)
            {
                parm.pPotPtr[i] = {};
                parm.pPotPtr[i].x = parseFloat(this.m_points[i].x);
                parm.pPotPtr[i].y = parseFloat(this.m_points[i].y);
            }

    }

    drawStereo(canvas){
        var byR0,byG0,byB0;
        var nR1,nG1,nB1;
        var Color = [];
        var rgbArr = [];
        rgbArr = this.borderColor.colorRgb();
        if(rgbArr.length != 3){
            byR0 = 0;
            byG0 = 0;
            byB0 = 255;
        }else{
            byR0 = rgbArr[0];
            byG0 = rgbArr[1];
            byB0 = rgbArr[2];
        }
        Color = this.lineTypeStyle.stereoColor.colorRgb();
        nR1 = Color[0];
        nG1 = Color[1];
        nB1 = Color[2];
        var fAddR,fAddG,fAddB;
        var w = Math.max(1,parseInt(this.borderWidth));
        fAddR = (nR1-byR0)/w;
        fAddG = (nG1-byG0)/w;
        fAddB = (nB1-byB0)/w;

        var faddx,faddy;
        var parm = {};
        parm.faddx = faddx;
        parm.faddy = faddy;
        parm.faddx = 0;	parm.faddy = 0.0;

        faddx = parm.faddx;
        faddy = parm.faddy;

        var nPenStyle;

        var nCount;
        var pPotPtr = [];

        var tempParm = {};
        tempParm.nCount = nCount;
        tempParm.pPotPtr = pPotPtr;

        this.GetPtr(tempParm);

        nCount = tempParm.nCount;
        pPotPtr = tempParm.pPotPtr;

        var nBakCount = tempParm.nCount;
        var pPotBak = new Array(nBakCount);
        var i=0;
        for(; i<nBakCount; i++)//备份点的信息
        {
            pPotBak[i] = {};
            pPotBak[i].x = pPotPtr[i].x;
            pPotBak[i].y = pPotPtr[i].y;
        }

        var bUsePath = 1;
        var fWidthAdd;
        if(parseInt(this.borderWidth) <= 8)
            fWidthAdd = 2.0;
        else
            fWidthAdd = 2.0 * parseInt(this.borderWidth)/32.0 + 2.0;

        i = -999;
        var ddddcount = 0;
        for(var fj =1.0; fj<=parseInt(this.borderWidth); fj+=fWidthAdd)
        {
            // ddddcount ++;
            if((i == Math.ceil(fj)) || (i == Math.ceil(fj)))
                continue;
            i = Math.ceil(fj);//这三行代码保证只有在线宽差距较大时才画，提高了效率

            var colorStyle = "rgb(";
            var tempr = byR0+fAddR*i>255?255:byR0+fAddR*i;
            var tempg = byG0+fAddG*i>255?255:byG0+fAddG*i;
            var tempb = byB0+fAddB*i>255?255:byB0+fAddB*i;
            colorStyle += Math.ceil(tempr) + "," + Math.ceil(tempg) + "," + Math.ceil(tempb) + ")";
            canvas.strokeStyle = colorStyle;
            canvas.lineWidth = parseInt(this.borderWidth) + 1 - i;
            for(var j=0; j<nCount; j++)
            {
                pPotPtr[j].x = pPotBak[j].x + /*ddddcount*10 +*/ Math.ceil(faddx*i)+this.cx;
                pPotPtr[j].y = pPotBak[j].y +  Math.ceil(faddy*i)+this.cy;
            }
            //测试填充颜色
            // canvas.fillStyle = "#EFC93C";//矩形填充颜色
            // canvas.fillRect(0,0,this.width,this.height);//矩形坐标及大小
            canvas.beginPath();
            // canvas.setLineDash([20]);
            canvas.moveTo(pPotPtr[0].x,pPotPtr[0].y);
            for(var i = 1 ;i < pPotPtr.length; i++) {
                canvas.lineTo(pPotPtr[i].x,pPotPtr[i].y);
            }
            canvas.stroke();
        }
    }
    onDraw(canvas){ 
        this.setCanvas(canvas)
        if(!this.isHide) return;
        if(!this.fcHide) return;
        this.formatRect();
        this.executePreAnimation(canvas);
        canvas.save();
        // canvas.lineJoin = 'round';
        if(this.lineTypeStyle != null){
            canvas.setLineDash(this.lineStyle(this.lineTypeStyle.turningStyle));
            //目前转译有问题， 现在只有 圆拐角
            if(this.lineTypeStyle.turningStyle == 0){
                canvas.lineJoin = 'round';
            }else if(this.lineTypeStyle.turningStyle == 1){
                canvas.lineJoin = 'round';
            }
            if(this.lineTypeStyle.startStyle == 2){
                canvas.lineCap = 'round';
            }else {
                canvas.lineCap = 'miter';
            }
            // if(this.lineTypeStyle.endStyle == 0){
            //     canvas.lineCap = 'miter';
            // }else if(this.lineTypeStyle.endStyle == 1){
            //     canvas.lineCap = 'round';
            // }
            if(this.lineTypeStyle.isStereo){
                this.drawStereo(canvas)
            }else{
                canvas.setLineDash(this.lineStyle(this.lineType));
                canvas.lineCap = 'round';
                canvas.lineJoin = 'round';
                
                canvas.beginPath();
                canvas.moveTo(parseFloat(this.cx + this.m_points[0].x),parseFloat(this.cy + this.m_points[0].y));
                for(var i = 1 ;i < this.m_points.length ; i++) {
                    canvas.lineTo(parseFloat(this.cx + this.m_points[i].x),parseFloat(this.cy + this.m_points[i].y));
                }
                canvas.lineWidth = this.borderWidth;
                if(this.color == ""){
                    canvas.fillStyle = "rgba(255, 255, 255, 0)";//矩形填充透明
                }else{
                    canvas.fillStyle = this.color;
                }
                canvas.strokeStyle = this.borderColor;
                if(this.transitionColor != 0){
                    canvas.globalAlpha = this.transitionColor/10;
                }
                //判断 不勾选“只有流动时才显示” 
                canvas.stroke();
            }
        }else{
            canvas.setLineDash(this.lineStyle(this.lineType));
            canvas.lineCap = 'round';
            canvas.lineJoin = 'round';
            
            canvas.beginPath();
            canvas.moveTo(parseFloat(this.cx + this.m_points[0].x),parseFloat(this.cy + this.m_points[0].y));
            for(var i = 1 ;i < this.m_points.length ; i++) {
                canvas.lineTo(parseFloat(this.cx + this.m_points[i].x),parseFloat(this.cy + this.m_points[i].y));
            }
            canvas.lineWidth = this.borderWidth;
            if(this.color == ""){
                canvas.fillStyle = "rgba(255, 255, 255, 0)";//矩形填充透明
            }else{
                canvas.fillStyle = this.color;
            }
            canvas.strokeStyle = this.borderColor;
            if(this.transitionColor != 0){
                canvas.globalAlpha = this.transitionColor/10;
            }
            //判断 不勾选“只有流动时才显示” 
            canvas.stroke();
            
        }
        canvas.closePath();
        this.Render(canvas);
        this.executePosAnimation(canvas);
        canvas.restore();
    }
}


// WEBPACK FOOTER //
// ./src/js/canvas/subUnit/fvPolylineObj.js